import { format } from 'date-fns';
import { useMemo } from 'react';
import { type AppointmentWithDetails } from 'types/appointments';
import { getSessionStatus, SESSION_STATUS } from './utils';

export const useSessionsSummary = (
  appointments: AppointmentWithDetails[]
): {
  total: number;
  confirmed: number;
  pending: number;
  today: number;
} =>
  useMemo(() => {
    const today = format(new Date(), 'yyyy-MM-dd');

    return appointments.reduce(
      (acc, appointment) => {
        const status = getSessionStatus(appointment);
        const isToday = appointment.dateTime.slice(0, 10) === today;

        return {
          total: acc.total + 1,
          confirmed: acc.confirmed + (status === SESSION_STATUS.CONFIRMED ? 1 : 0),
          pending: acc.pending + (status === SESSION_STATUS.PENDING ? 1 : 0),
          today: acc.today + (isToday ? 1 : 0),
        };
      },
      { total: 0, confirmed: 0, pending: 0, today: 0 }
    );
  }, [appointments]);
